module.exports = __webpack_public_path__ + "img/empreendimento-logo-35.c4c8b15a.png";